export default __webpack_public_path__ + "static/media/weapon1.286628bf.png";